// Enums
import { Roles } from '../../modules/auth/models/roles.enum';
import { StatusType } from '../enums';

// Models
import { AppCleanup } from '../models';

export class MenuConfig extends AppCleanup {
	items: MenuModel[] = [
		{
			title: 'Active Jobs',
			root: true,
			icon: 'in-progress',
			svgIcon: true,
			page: '/job',
			bullet: 'dot',
			// May use this later
			// header: {
			// 	self: {},
			// 	items: [
			// 		{
			// 			title: 'Daily Reports'
			// 		}
			// 	]
			// },
			roles: [Roles.TenantAdmin, Roles.SuperAdmin, Roles.Admin, Roles.Member],
		},
		{
			title: 'Completed Jobs',
			root: true,
			icon: 'check_circle',
			page: '/job/complete',
			bullet: 'dot',
			roles: [Roles.TenantAdmin, Roles.SuperAdmin, Roles.Admin, Roles.Member],
		},
		{
			title: 'Companies',
			root: true,
			icon: 'company',
			svgIcon: true,
			page: '/company',
			bullet: 'dot',
			hidden: this.isViewer,
			roles: [Roles.TenantAdmin, Roles.SuperAdmin, Roles.Admin, Roles.Member],
		},
		{
			title: 'Channels',
			root: true,
			icon: 'speed',
			page: '/channel',
			bullet: 'dot',
			hidden: this.isViewer,
			roles: [Roles.TenantAdmin, Roles.SuperAdmin],
		},
		{
			title: 'Comments',
			root: true,
			icon: 'message',
			page: '/comment',
			bullet: 'dot',
			hidden: this.isViewer,
			roles: [Roles.TenantAdmin, Roles.SuperAdmin],
		},
		{
			title: 'Districts',
			root: true,
			icon: 'location_on',
			page: '/district',
			bullet: 'dot',
			hidden: this.isViewer,
			roles: [Roles.TenantAdmin, Roles.SuperAdmin, Roles.Admin],
		},
		{
			title: 'Unit of Measure',
			root: true,
			icon: 'straighten',
			page: '/unit-of-measure',
			bullet: 'dot',
			hidden: this.isViewer,
			roles: [Roles.TenantAdmin, Roles.SuperAdmin],
		},
		{
			title: 'Users',
			root: true,
			icon: 'groups',
			page: '/user',
			bullet: 'dot',
			hidden: this.isViewer,
			roles: [Roles.TenantAdmin, Roles.SuperAdmin, Roles.Admin],
		},
		{
			title: 'Assets',
			root: true,
			icon: 'pie_chart', // construction
			page: '/asset',
			roles: [Roles.TenantAdmin, Roles.SuperAdmin, Roles.Admin],
			submenu: [
				{
					title: 'Units',
					root: false,
					icon: 'local_shipping',
					page: '/asset/unit',
				},
				{
					title: 'Strings',
					root: false,
					icon: 'timeline',
					page: '/asset/string',
					hidden: true,
				},
				{
					title: 'Reels',
					root: false,
					icon: 'panorama_horizontal_select', // fiber_smart_record, panorama_vertical_select
					page: '/asset/reel',
					hidden: true,
				},
				{
					title: 'BOPs',
					root: false,
					icon: 'local_fire_department', // shield
					page: '/asset/bop',
					hidden: this.isViewer,
				},
				{
					title: 'Devices',
					root: false,
					icon: 'devices',
					page: '/asset/device',
					hidden: this.isViewer && !this.isEdge,
					roles: [Roles.TenantAdmin, Roles.SuperAdmin],
				},
			],
		},
		{
			title: 'Output',
			root: true,
			icon: 'output',
			page: '/output-config',
			hidden: !this.isViewer,
			bullet: 'dot',
			roles: [Roles.TenantAdmin, Roles.SuperAdmin, Roles.Admin, Roles.Member],
		},
		// {
		// 	title: 'Unit Config.',
		// 	root: true,
		// 	icon: 'input', // settings_input_component
		// 	page: '/unit-config',
		// 	bullet: 'dot',
		// 	hidden: !this.isViewer,
		// 	roles: [Roles.TenantAdmin, Roles.SuperAdmin, Roles.Admin, Roles.Member]
		// },
		{
			title: 'Extras',
			root: true,
			svgIcon: true,
			icon: 'details',
			bullet: 'dot',
			roles: [Roles.TenantAdmin, Roles.SuperAdmin],
			bottom: true,
			submenu: [
				{
					title: 'Downloads',
					root: false,
					icon: 'downloading',
					page: '/download',
					hidden: this.isViewer,
				},
				{
					title: 'Versions',
					root: false,
					icon: 'update',
					page: '/version',
				},
			],
		},
	];

	get menuItems(): any {
		return this.items;
	}
}

export class MenuModel {
	title: string;
	root: boolean;
	icon: string;
	svgIcon?: boolean;
	page?: string;
	bullet?: string;
	roles?: Roles[];
	bottom?: boolean;
	hidden?: boolean;
	submenu?: MenuModel[];
	badge?: MenuBadgeModel;
}

export class MenuBadgeModel {
	type?: StatusType;
	value: string | number;
	label: string;
}
